import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "showIcon", "hideIcon"]

  toggle() {
    const visible = this.inputTarget.type === "text"
    this.inputTarget.type = visible ? "password" : "text"
    this.buttonTarget.setAttribute("aria-label", visible ? this.buttonTarget.dataset.showLabel : this.buttonTarget.dataset.hideLabel)
    this.buttonTarget.setAttribute("aria-pressed", String(!visible))
    this.showIconTarget.classList.toggle("hidden", !visible)
    this.hideIconTarget.classList.toggle("hidden", visible)
  }
}
